import { render, staticRenderFns } from "./lookingForCard.vue?vue&type=template&id=6ac55970&scoped=true&"
import script from "./lookingForCard.vue?vue&type=script&lang=js&"
export * from "./lookingForCard.vue?vue&type=script&lang=js&"
import style0 from "./lookingForCard.vue?vue&type=style&index=0&id=6ac55970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac55970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac55970')) {
      api.createRecord('6ac55970', component.options)
    } else {
      api.reload('6ac55970', component.options)
    }
    module.hot.accept("./lookingForCard.vue?vue&type=template&id=6ac55970&scoped=true&", function () {
      api.rerender('6ac55970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/crudApp/lookingForCard.vue"
export default component.exports